import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory,useLocation } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import { DeleteAccount } from "../../../redux/actions/AuthAction";

const DeleteAccModal = ({ userId }) => {
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const history = useHistory();
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const deleteAcc = () =>{
    setLoader(true)
    const onSuccess = () =>{
      setLoader(false)
      localStorage.clear();
      localStorage.setItem("IS_LOGOUT", true);
      window.location.href = "/";

    }

    const onError = (msg) =>{
        setLoader(false)
        openSnackbar(msg);
    }

    DeleteAccount({learnerId:userId},onSuccess,onError)
  }

  return (
    <>
    {
      location.pathname === "/my_profile"?
      <button className="btn text-primary" onClick={handleShow}>
         <i className="fa fa-trash" aria-hidden="true"></i> Delete account
      </button>
      :""
    }

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body>
          <h5 className="modal-title">Remove account?</h5>
          <div className="modal-body">
            <p>
              Removing this account will delete all of data related to session,
              subscriptions and other data from our servers.
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => handleClose()}
            >
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={()=>deleteAcc()} disabled={loader}>
              {loader?"Loading...":"Remove account"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteAccModal;
